import { FC } from "react";

import { useQueryClient } from "@tanstack/react-query";

import {
  getGetTipsPerformanceQueryKey,
  getGetUpcomingTipsQueryKey,
  getGetUserTipsQueryKey,
} from "@api";

import {
  Dropdown,
  DropdownContent,
  DropdownItem,
  DropdownPlacement,
} from "@ui/components";
import { Icon, ImageComponent } from "@ui/elements";
import { Stack } from "@ui/layout";

import { useTranslationContext } from "../TranslationProvider";

import "./LanguageSelect.scss";

const localeLabels = {
  en: "English",
  hu: "Magyar",
};

type LanguageSelectProps = {
  dropdownPlacement?: DropdownPlacement;
};

export const LanguageSelect: FC<LanguageSelectProps> = ({
  dropdownPlacement = "bottom-end",
}) => {
  const { changeLocale, locale } = useTranslationContext();
  const queryClient = useQueryClient();

  const handleSelectChange = async (targetLocale: string) => {
    changeLocale(targetLocale);

    await queryClient.invalidateQueries({
      queryKey: getGetUpcomingTipsQueryKey({ type: "value" }),
    });
    await queryClient.invalidateQueries({
      queryKey: getGetUpcomingTipsQueryKey({ type: "resultOriented" }),
    });

    await queryClient.invalidateQueries({
      queryKey: getGetTipsPerformanceQueryKey({ type: "value" }),
    });
    await queryClient.invalidateQueries({
      queryKey: getGetTipsPerformanceQueryKey({ type: "resultOriented" }),
    });

    await queryClient.invalidateQueries({
      queryKey: getGetUserTipsQueryKey({ type: "value" }),
    });
    await queryClient.invalidateQueries({
      queryKey: getGetUserTipsQueryKey({ type: "resultOriented" }),
    });
  };

  const label = localeLabels[locale as keyof typeof localeLabels];

  return (
    <div>
      <Dropdown
        trigger={
          <Stack gap="xxs" align="center" className="language-select">
            <Icon icon="GlobeSimple" />
            {label}
          </Stack>
        }
        placement={dropdownPlacement}
      >
        <DropdownContent>
          <DropdownItem onClick={() => handleSelectChange("en")}>
            <ImageComponent size={16} isRounded src={`/flags/en.png`} /> English
          </DropdownItem>
          <DropdownItem onClick={() => handleSelectChange("hu")}>
            <ImageComponent size={16} isRounded src={`/flags/hu.png`} /> Magyar
          </DropdownItem>
        </DropdownContent>
      </Dropdown>
    </div>
  );
};
